
export const breakpoints = {
  sm: '(min-width: 30em)',
  md: '(min-width: 48em)',
  lg: '(min-width: 59em)',
  // 1200px — wide enough for a 3/4 column to hold an ~854px panel (see Report/index.js)
  xl: '(min-width: 75em)'
}

const config = {
  breakpoints
}

export default config

